import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en';
import ar from './ar';

// This is the main configuration file for i18next.
// It initializes the library with the necessary plugins and settings.

// Initialize i18next instance
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en.translation },
      ar: { translation: ar.translation },
    },
    fallbackLng: 'en',
    debug: false, // disables all i18next debug logs
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      // Don't re-detect on visibility change or focus
      checkWhitelist: true,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    returnNull: false,
    returnEmptyString: false,
    returnObjects: true,
    saveMissing: false, // disables missing key warnings
    // Add missing key handler for better debugging (no-op)
    missingKeyHandler: () => {},
  });

// Silence all i18next warnings/errors after init
if (i18n.services && i18n.services.logger) {
  i18n.services.logger.log = () => {};
  i18n.services.logger.warn = () => {};
  i18n.services.logger.error = () => {};
}

// Handle language direction
i18n.on('languageChanged', (lng) => {
  const direction = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = direction;
  document.documentElement.lang = lng;
  // Also save to localStorage to ensure persistence
  localStorage.setItem('i18nextLng', lng);
});

// Ensure initial language direction is set correctly
const initialLang = localStorage.getItem('i18nextLng') || i18n.language || 'en';
document.documentElement.dir = initialLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = initialLang;

export default i18n;
